var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_ol_line_style_interface = function () {
    OCS.Viewer.Interfaces.OlLineStyle = {
        options: {
            layer_style_ops: {},
            line_style_type_text: 'line',
            line_style_ops: {
                fill_color: '#fff',
                fill_width: 2,
                stroke_color: '#fff',
                stroke_width: 5,
                text: {
                    font_size: '16px',
                    font_family: 'helvetica,arial,sans-serif',
                    fill_color: 'rgba(0, 0, 0, 1)',
                    fill_width: 2,
                    stroke_color: 'rgba(255, 255, 255, 1)',
                    stroke_width: 4
                }
            }
        },
        get_line_layer_style_method: function (in_feature, res) {
            var feature = in_feature;
            var text, ops, style;
            if (this.options.layer_style_ops.value_var) {
                text = feature.get(this.options.layer_style_ops.value_var);
                if (this.options.layer_style_ops.hasOwnProperty('label_contours') && this.options.layer_style_ops.label_contours) {
                    text = (text) ? (this.options.layer_style_ops.prefix ? this.options.layer_style_ops.prefix : "") + parseFloat(text).toFixed(this.options.layer_style_ops.label_precision) + (this.options.layer_style_ops.suffix ? this.options.layer_style_ops.suffix : "") : "";
                }
            }
            if (!this.style_cache[text]) {
                // Get the style object given the options we have
                ops = {};
                if (this.options.layer_style_ops.hasOwnProperty('label_contours') && this.options.layer_style_ops.label_contours) {
                    ops.text = {};
                    ops.text.text = text;
                }
                if (this.options.layer_style_ops.hasOwnProperty('line_color')) {
                    ops.stroke_color = this.options.layer_style_ops.line_color.substring(0, 7);
                }
                if (this.options.layer_style_ops.hasOwnProperty('width')) {
                    ops.stroke_width = parseFloat(this.options.layer_style_ops.width);
                }
                style = this.get_style_with_ops(this.build_style_ops(this.set_style_ops(this.options.line_style_ops, ops)));
                this.style_cache[text] = [style];
            }
            return this.style_cache[text];
        }
    }; // End OCS.Viewer.Interfaces.OlLineStyle
};
OCS.Viewer.Functions.define_ol_line_style_interface();